// eslint-disable-next-line import/prefer-default-export
export enum TimeUnit {
  Second = 1000,
  Minute = Second * 60,
  Hour = Minute * 60,
}
